export const highlights = [
  {
    icon: "ri-sword-line",
    accent: "primary",
    title: "战斗演出更讲分镜逻辑",
    body: "本季战斗番普遍减少无意义炫技，转向用镜头语言交代人物位置与攻防关系。看懂分镜之后再回看关键场面，会发现信息量比第一遍更多。",
    tag: "战斗 / 动作",
  },
  {
    icon: "ri-magic-line",
    accent: "accent",
    title: "奇幻题材回到「设定扎实」",
    body: "从地下城到旅途敘事，多部奇幻作品把重心放在世界观的可信度上，用细节堆出沉浸感，而不是靠单点奇观撑场面。",
    tag: "奇幻 / 冒险",
  },
  {
    icon: "ri-music-2-line",
    accent: "secondary",
    title: "音乐与青春题材持续走高",
    body: "乐队与社团题材用夸张演出表现内心戏，笑点与情绪释放并存。这类作品适合一次连看数集，情绪连贯性会更好。",
    tag: "音乐 / 青春",
  },
  {
    icon: "ri-search-eye-line",
    accent: "primary",
    title: "推理内容开始考验观众参与感",
    body: "含有推理元素的作品会在台词与画面里埋下线索，边看边记的习惯能显著提升解谜体验，也更容易发现伏笔回收的精妙之处。",
    tag: "悬疑 / 推理",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先看标签，再定清单",
    body: "用本页的标签筛选把题材偏好圈出来，先列出 3 到 5 部目标作品，避免一上来铺太开导致追不完。",
  },
  {
    step: "02",
    title: "按番剧表安排时间",
    body: "在放送日历里对照每周更新日，把观看时间固定在固定的晚上，形成节奏后就不容易遗忘进度。",
  },
  {
    step: "03",
    title: "用排行做取舍",
    body: "时间有限时，优先跟人气榜与评分榜里交集较多的作品；期待榜则用来安排下一季的候补名单。",
  },
  {
    step: "04",
    title: "三集之后再决定",
    body: "慢热作品常在前三集铺垫，别急着弃番。给每部作品三集的机会，再判断是否继续跟进。",
  },
];

export const collectorImage =
  "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20stack%20of%20colorful%20blu-ray%20volumes%20and%20posters%20beside%20a%20notebook%20with%20a%20pen%2C%20warm%20desk%20lamp%20light%2C%20stylized%20flat%20anime%20art%20style%2C%20soft%20coral%20and%20amber%20palette%2C%20organized%20cozy%20composition%2C%20consistent%20art%20direction%2C%20simple%20clean%20background&width=900&height=1000&seq=anime-guide-img&orientation=portrait";